import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';

const OTPTimer = forwardRef(({ initialTime, onComplete }, ref) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [isRunning, setIsRunning] = useState(true);

  useImperativeHandle(ref, () => ({
    resetTimer: () => {
      setTimeLeft(initialTime);
      setIsRunning(true);
    }
  }));

  // 1. Logic to handle the Ticking (Pure state update)
  useEffect(() => {
    let timer = null;
    if (isRunning && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [isRunning, timeLeft]);

  // 2. Logic to handle Completion (Side Effect)
  // This runs AFTER the render, preventing the "Cannot update..." error
  useEffect(() => {
    if (timeLeft === 0 && isRunning) {
      setIsRunning(false);
      if (onComplete) {
        onComplete();
      }
    }
  }, [timeLeft, isRunning, onComplete]);

  // Format Helper
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <span>{formatTime(timeLeft)}</span>
  );
});

export default OTPTimer;